(window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll'];

import { bootstrapApplication as bootstrapCustomerPortal } from '@angular/platform-browser';
import { customerPortalConfig as ConfigCustomerPortal } from './customer-portal/customer-portal.config';
import { CustomerPortal as ViewCustomerPortal } from './customer-portal/customer-portal';
import { environment } from './environments/environment';
import posthog from 'posthog-js';

const POSTHOG_KEY = environment.posthog;
posthog.init(POSTHOG_KEY, {
  api_host: 'https://us.i.posthog.com',
  capture_pageview: false,
  capture_pageleave: false,
  person_profiles: 'identified_only'
});

bootstrapCustomerPortal(ViewCustomerPortal, ConfigCustomerPortal).catch(err => console.error(err));
